import React from 'react';

import SubAbas from './subabas';
import BarraInferiorBotoes from '../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../components/BarraSubAbas';
import ContainerConteudo from '../../../components/ContainerConteudo';
import PageBuilding from '../../../components/PageBuilding';
import WorkspaceBotoes from '../../../components/WorkspaceBotoes';
import { isActionAllowed } from '../../../modules/contexts/Auth/RequireAuth';
import { useModuloUsuario } from '../../../services/enum/useModuloUsuario';
import { usePapelUsuario } from '../../../services/enum/usePapelUsuario';
//DADOS USUARIO
//const entity = ENTITY.ENTITY_Programacao;

const ProgramacaoIndex: React.FC = () => {
  //PERMISSOES
  const papelUsuarioOptions = usePapelUsuario();
  const moduloUsuarioOptions = useModuloUsuario();
  // Obter o módulo
  const MODULO = Number(
    moduloUsuarioOptions.find((modulo) => modulo.label === 'Programação')
      ?.value || '0',
  );

  // Verificar permissões para ações
  const btDisable = isActionAllowed(MODULO, 'crud', papelUsuarioOptions);
  //PERMISSOES

  return (
    <>
      <BarraSubAbas subAbas={SubAbas} />

      <ContainerConteudo>
        <PageBuilding></PageBuilding>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          downloadDisabled={btDisable}
          inserir
          inserirDisabled={btDisable}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default ProgramacaoIndex;
